<template>
    <div class="main-container">
        <v-row class="justify-center mb-4">
            <v-img
                max-width="180px"
                src="../assets/sesi-logo.png"
                style="cursor: pointer;"
            ></v-img>
        </v-row>

        <v-row class="justify-center mb-4">
            <h3 class="text-center primary--text font-weight-bold blue--text">
                SELECIONE A UNIDADE
            </h3>
        </v-row>

        <v-card class="pa-5 mx-auto full-width" outlined>
            <v-row class="justify-center">
                <v-col cols="12" md="6" v-for="unidade in unidadesList" :key="unidade.IdUnidade">
                    <v-btn
                        color="primary"
                        class="mx-2 my-4"
                        large
                        height="80px"
                        elevation="5"
                        block
                        @click="confirmSelection(unidade.IdUnidade, unidade.Unidade)"
                    >
                        {{ unidade.Unidade }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>

        <AlertSystem :snackbar="system.snackbar"></AlertSystem>
    </div>
</template>

<script>
import axios from 'axios';
import AlertSystem from "../components/AlertSystem";

export default {
    components:{
        AlertSystem,
    },
    data() {
        return {
            unidadesList: [],
            IdUnidadeSelecionado: null,
            selectedUnit: null,
            loadingUnidades: false,
            system: {
                snackbar: {},
            },
        };
    },
    computed: {
        getSelectedUnitName() {
            const unidade = this.unidadesList.find(u => u.IdUnidade === this.IdUnidadeSelecionado);
            return unidade ? unidade.Unidade : '';
        },
    },
    methods: {
        async fetchUnidades() {
            this.loadingUnidades = true;
            try {
                const response = await axios.get('/senharecepcao/unidades');
                this.unidadesList = response.data;
            } catch {                
                alert('Não foi possível carregar a lista de unidades. Tente novamente mais tarde.');
            } finally {
                this.loadingUnidades = false;
            }
        },
        confirmSelection(IdUnidade, Unidade) {
            if (IdUnidade && Unidade) {
                this.$router.push({
                    path: '/satisfacaoForm',
                    query: {
                        Unidade: Unidade,
                        IdUnidade: IdUnidade
                    },
                });
            } else {
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Por favor, selecione uma unidade antes de continuar.',
                    color: "red",
                };
            }
        },
    },
    mounted() {
        this.fetchUnidades();
    },
};
</script>

<style scoped>
.main-container {
    margin: 0 auto;
    padding: 20px;
}
</style>
